import React, { useCallback, useState, useEffect } from 'react';
import { TextField, Autocomplete } from '@mui/material';
import './autocomplete.module.css';
import { Product } from 'types/product';
import { toast } from 'react-toastify';
import { api } from 'services/api';
import ProductItem from './ProductItem';

let timer: NodeJS.Timeout;

interface AutocompleteFromProps {
  onSelect(value: Product | null): void;
  label: string;
  placeholder: string;
  selected: Product | null;
  helperText?: string;
  error?: boolean;
}

const ProductsAutoComplete: React.FC<AutocompleteFromProps> = ({
  onSelect,
  label,
  placeholder,
  selected,
  helperText = '',
  error = false,
}) => {
  const [loading, setLoading] = useState(false);
  const [filtered, setFiltered] = useState<Product[]>([]);
  const [options, setOptions] = useState<Product[]>([]);

  const handleSelect = useCallback(
    (option: Product) => {
      onSelect(option);
      setFiltered([]);
    },
    [onSelect],
  );

  useEffect(() => {
    setFiltered(options);
  }, [options]);

  const findProducts = useCallback(async (term: string) => {
    setLoading(true);
    api
      .get('/products/all', { params: { name: term } })
      .then(response => {
        setOptions(response.data);
      })
      .catch(err => {
        toast.error('Ocorreu um erro ao buscar os produtos');
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  function handleChange(value: string) {
    clearTimeout(timer);

    if (value.length < 2) {
      return;
    }

    timer = setTimeout(() => findProducts(value), 400);
  }

  return (
    <Autocomplete
      value={selected}
      options={filtered}
      noOptionsText="Nenhum produto encontrado"
      getOptionLabel={option => option.name}
      onChange={(event, newValue) => onSelect(newValue)}
      renderOption={(props, option) => (
        <ProductItem {...props} key={option.id} handleSelect={handleSelect} option={option} selected={selected} />
      )}
      renderInput={params => (
        <TextField
          {...params}
          onBlur={() => setFiltered([])}
          onChange={e => handleChange(e.target.value)}
          label={label}
          placeholder={placeholder}
          error={error}
          helperText={helperText || 'Digite 2 ou mais caracteres'}
          fullWidth
        />
      )}
    />
  );
};

export default ProductsAutoComplete;
